import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import "./css/gallery.css";

const CustomArrow = ({ className, onClick, direction }) => (
  <button
    className={`${className} custom-arrow ${
      direction === "prev" ? "left-[-20px]" : "right-[-20px]"
    }`}
    onClick={onClick}
    aria-label={direction === "prev" ? "Previous Slide" : "Next Slide"}
  >
    {direction === "prev" ? "<" : ">"}
  </button>
);

const Gallery = ({ galleryData }) => {

  const { tagline, color, images } = galleryData;
  
// Carousel settings
const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 4, // Default for large screens
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 3000,
  centerMode: true,
  centerPadding: "0",
  nextArrow: <CustomArrow direction="next" />,
  prevArrow: <CustomArrow direction="prev" />,
  responsive: [
    {
      breakpoint: 1440, // MacBook screens
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        centerMode: false,
      },
    },
  ],
};


  return (
    <div className="w-full flex justify-center ">
    <div className="w-full flex flex-col sm:w-full md:w-full lg:w-4/5 xl:w-5/6  md:px-0  mt-3">
       <div>
          {tagline && (
            <h2 className="text-center section-title__title">{tagline}</h2>
          )}
          <Slider {...settings}>
            {images.map((data, index) => (
              <div
                key={index}
                className="flex mt-3  md:max-w-[500px] w-full items-center"
              >
                <img
                  src={data.image}
                  alt={`Gallery item ${index + 1}`}
                  className="w-full h-[350px] object-cover rounded-lg"
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
